import { ClientLocal, IReduxState } from "app/api/types";
import {
	CHANGE_TELEGRAM, UPDATE_CHAT_MESSAGES, GET_MESSAGE,
	UPDATE_CHATS, ADD_MESSAGE, GET_NOTIFICATION, GET_REGISTRATION, RESET_NOTIFICATION
} from "./actions";
import { addChatMessage, updateChatMessages } from "./reducers/updateChatMessages";
import { addChatClient } from "./reducers/updateChatClients";
import { updateNotificationStatus } from "./reducers/updateNotificationStatus";

type IState = { chats: Array<ClientLocal>, telegram: string | null } & IReduxState;

const initialState: IState = {
	isLoading: false,
	chats: [],
	telegram: null,
};

const chatReducer = (
	state = initialState,
	action: { type: string; payload: any }
) => {
	switch (action.type) {
		case CHANGE_TELEGRAM:
			return {
				...state,
				telegram: action.payload as string,
			}
		case UPDATE_CHATS:
			return {
				...state,
				chats: action.payload as ClientLocal[],
			}
		case UPDATE_CHAT_MESSAGES:
			return {
				...state,
				chats: updateChatMessages(state.chats, action.payload)
			}
		case GET_MESSAGE:
		case ADD_MESSAGE:
			return {
				...state,
				chats: addChatMessage(state.chats, action.payload)
			}
		case GET_REGISTRATION:
			return {
				...state,
				chats: addChatClient(state.chats, action.payload)
			}
		case GET_NOTIFICATION:
			return {
				...state,
				chats: updateNotificationStatus(state.chats, action.payload, true)
			}
		case RESET_NOTIFICATION:
			return {
				...state,
				chats: updateNotificationStatus(state.chats, action.payload, false)
			}
		default:
			return state;
	}
}

export default chatReducer;
